module.exports = __webpack_public_path__ + "assets/media/no.84267bba.mp3";